import styled from "styled-components";

const ButtonsWrapperStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  column-gap: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ButtonsWrapper = (props) => {
  return <ButtonsWrapperStyled>{props.children}</ButtonsWrapperStyled>;
};
